import React, { useState } from 'react';
import '../css/settings.css'; 
import { saveUser } from '../api/api';

const Settings = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const response = await saveUser({ username, password });
      alert(response.message || 'Saved successfully!');
      setUsername('');
      setPassword('');
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || 'failed to save user');
    }
  };

  return (
    <div className="page-wrapper">
     
      <form className="settings-form" onSubmit={handleSave}>
        <div className="form-group">
          <label>Username:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter username"
            required
          />
        </div>

        <div className="form-group">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            required
          />
        </div>

        <button type="submit" className="save-btn">Save</button>
      </form>
    </div>
  );
};

export default Settings;
